import { render, staticRenderFns } from "./TKStatusWidget.vue?vue&type=template&id=0193fa54&scoped=true&"
import script from "./TKStatusWidget.vue?vue&type=script&lang=ts&"
export * from "./TKStatusWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TKStatusWidget.vue?vue&type=style&index=0&id=0193fa54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193fa54",
  null
  
)

export default component.exports